import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import type { StoriesWrittenReRoute } from 'teacher-ui-client/reporting/ui-scope/re/stories-written/route'
import { t } from 'ember-intl'
import { array } from '@ember/helper'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import ReportingTeacherUiHeader from 'teacher-ui-client/components/reporting/teacher-ui-header'
import ReportingDetailedControls from 'teacher-ui-client/components/reporting/detailed-controls'
import ReportingNoDataMessageIf from 'teacher-ui-client/components/reporting/no-data-message-if'
import { StoriesWrittenTotals } from 'teacher-ui-client/components/giraffe/charts/stories-written/totals'
import { StoriesWrittenHistory } from 'teacher-ui-client/components/giraffe/charts/stories-written/history'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import fullGradeName from 'teacher-ui-client/helpers/full-grade-name'
import { not } from 'ember-truth-helpers'
import { camelize } from '@ember/string'
import { concat } from '@ember/helper'

interface Signature {
  model: ModelFor<StoriesWrittenReRoute>
}

export const ReStoriesWritten: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.storiesWritten"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{if @model.storiesWrittenTotals true false}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.re.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.storiesWrittenTotals}}>
    {{#each @model.storiesWrittenTotals as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <StoriesWrittenTotals
          @data={{gradeData}}
          @title={{t "reporting.chartTitles.storiesWrittenTotals"}}
          @summaryTitle={{t (concat "reporting.summaryTitles.storiesWrittenTotals." (camelize @model.uiScope.scope))}}
          @tooltip={{t "reporting.tooltips.storiesWrittenTotals"}}
          @grade={{fullGradeName gradeData.grade_position}}
        />
      </div>
    {{/each}}
    {{#if @model.storiesWrittenHistory}}
      <div class="my-10">
        <StoriesWrittenHistory
          @storiesWrittenHistoryData={{@model.storiesWrittenHistory}}
          @subco={{(isSubco)}}
          @students={{@model.scopedStudents}}
          @uiScope={{@model.uiScope.scope}}
          @tooltip={{t "reporting.tooltips.storiesWrittenHistory"}}
          @studentRouteName="reporting.ui-scope.re.student-summary"
        />
      </div>
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReStoriesWritten)
